import { Fragment, SyntheticEvent, useState } from "react";
import {Grid, IconButton, Tooltip, Typography} from "@mui/material";
import DownloadAttachment from "../../common/download-attachment/DownloadAttachment";
import { DeleteRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Attachment, IExpiredRecoveryEntrustmentForm } from "../../models/models";
import ExpiredCustomDialog from "../../common/dialog/ExpiredCustomDialog";
import { useSetRecoilState } from "recoil";
import { excludedExpiredRecoveratorAttachmentState } from "../../state";

const EntrustmentAttachments = ({postAction}: {postAction?: Function}) => {

    const {t} = useTranslation("expiredManagement");

    const [itemToExcludeDialogProps, setItemToExcludeDialogProps] = useState<{
        open: boolean,
        item: any
    }>({
        open: false,
        item: null
    });

    const form = useFormContext<IExpiredRecoveryEntrustmentForm>();
    const {fields: attachmentList, remove} = useFieldArray<IExpiredRecoveryEntrustmentForm, 'attachmentList'>({
        name: 'attachmentList',
        control: form.control
    });

    const setExcludedAttachments = useSetRecoilState(excludedExpiredRecoveratorAttachmentState);

    const handleExcludeAttachment = (e: SyntheticEvent, item: any) => {
        e.stopPropagation();

        setItemToExcludeDialogProps({
            open: true,
            item: item
        });
    }

    const onClose = () => {

        setItemToExcludeDialogProps({
            open: false,
            item: null
        });
    }

    const excludeAttachment = async () => {

        if (!!itemToExcludeDialogProps.item) {
            const indexToRemove = attachmentList.findIndex((x: any) => x.id === itemToExcludeDialogProps.item.id);
            
            if (indexToRemove !== -1) {
                remove(indexToRemove);
                setExcludedAttachments((prev) => {
                    return [...prev, itemToExcludeDialogProps.item.code];
                });
                onClose();
            }
        }
    }

    return (
        <>
            <Grid container spacing={2}>
                {
                    attachmentList?.map((item: Attachment) => (
                        <Fragment key={item.code}>
                            <Grid item xs={11} md={5} sx={{ display: 'flex', alignItems: 'center'}}>
                                {item.filename}
                            </Grid>

                            <Grid item xs={1} gap={1} sx={{ display: 'flex', alignItems: 'center'}}>
                                <DownloadAttachment attachment={item} />

                            
                                <Tooltip title={t('common.button.exclude')} arrow>
                                    <IconButton color={'secondary'} onClick={(e) => handleExcludeAttachment(e, item)}>
                                        <DeleteRounded />
                                    </IconButton>
                                </Tooltip>

                            </Grid>
                        </Fragment>
                    ))
                }
            </Grid>

            <ExpiredCustomDialog 
                open={itemToExcludeDialogProps.open}
                contentDescription={
                    <Typography color="primary" variant="body1">
                        {t('common.message.dialog.excludeAttachment')}
                    </Typography>
                }
                buttonCloseDescription={t('common.button.cancel')}
                buttonConfirmDescription={t('common.button.confirm')}
                onClose={onClose}
                onConfirm={excludeAttachment}
            />
        </>
    )
}

export default EntrustmentAttachments;